import { useQuery, useSubscription } from "@apollo/client";
import {
  MY_HR_CHANGE_REQUESTS_SUBSCRIPTION,
  MY_HR_GET_CHANGE_REQUESTS,
} from "my-hr/graphql";

export const useMyHrChangeRequests = (employee: string) => {
  const { data, loading, error, refetch } = useQuery(
    MY_HR_GET_CHANGE_REQUESTS,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        employee,
      },
    },
  );

  useSubscription(MY_HR_CHANGE_REQUESTS_SUBSCRIPTION, {
    onData: () => {
      refetch();
    },
  });

  const result = data?.changeRequests || [];

  return {
    data: result,
    loading,
    error,
    refetch,
  };
};

export default useMyHrChangeRequests;
